import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { UserPlus, ArrowRight } from "lucide-react";
import { BrutalButton } from "@/components/ui/BrutalButton";
import { useAuth } from "@/contexts/AuthContext";

export const CTABanner = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  // Don't show registration CTA if user is already logged in
  if (isAuthenticated) {
    return null;
  }

  return (
    <section className="py-12 px-4 bg-gradient-to-r from-primary/20 to-accent/20 border-y-[3px] border-dark">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <UserPlus className="w-10 h-10 text-primary" />
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold mb-3">
          {t("home.ctaBannerTitle")}
        </h2>
        <p className="text-lg text-muted-foreground mb-6 max-w-2xl mx-auto">
          {t("home.ctaBannerSubtitle")}
        </p>
        <Link to="/auth/register">
          <BrutalButton size="lg" className="gap-2">
            {t("home.ctaBannerButton")}
            <ArrowRight className="w-5 h-5" />
          </BrutalButton>
        </Link>
      </div>
    </section>
  );
};
